export const common = {
  nav: {
    home: '首页',
    about: '公司介绍',
    products: '产品介绍',
    technology: '技术原理',
    features: '安装案例及效果',
    catalog: '目录',
    contact: '客户支持',
    caseStudies: '安装案例及效果',
    featuresSubMenu: {
      item1: '压缩机',
      item2: '冷冻/冷藏',
      item3: '空调',
      item4: '压力机',
      item5: '粉碎机',
      item6: '注塑机',
      item7: '生产设备(综合)',
      item8: '水处理/废水处理',
      item9: '焊接设备',
      item10: '锅炉',
      item11: '照明/办公/电热',
    },
  },
  hero: {
    badge: 'AI第四次工业时代的电力解决方案',
    title: '赛碧斯',
    subtitle: 'AI第四次工业时代的电力解决方案\n应用负磁阻效应的下一代节电技术',
    trustBadge: '经过1-2个月的预先测量确认节省率后签约',
    spaceTech: '空间能源株式会社',
    spaceTechRole: '技术',
    sepisSolution: '赛碧斯株式会社',
    sepisSolutionRole: '解决方案',
    collaboration: '合作诞生',
    collaborationResult: '合作诞生',
    industrialSolution: '工业用电力效率解决方案',
    mainTitle: '工业用节电器',
    savingsHighlight: '通过节省5-8%的电费提高盈利能力',
    mainSubtitle: '通过节省5-8%의电费提高盈利能力',
    viewProducts: '查看产品阵容',
    contactUs: '咨询引进',
    stats: {
      savings: '平均节电率',
      recovery: '投资回收期',
      cases: '安装案例',
      monitoring: '实时监控',
    },
  },
  about: {
    label: 'ABOUT 赛碧斯',
    title: '韩国代表性节电产品',
    subtitle: '赛碧斯应用负磁阻效应\n实现AI时代的电力效率',
    company: '赛碧斯株式会社는',
    companyDesc: '在国内和全球销售赛碧斯产品的专业流通公司',
    companyIntro: '赛碧스株式会社是在国内和全球销售赛碧스产品的专业流通公司',
    description: '赛碧스는 기술 혁신의 부자기 효과 기술을 기반으로 개발된 다음 세대의 절전 솔루션입니다. AI 4차 산업 시대의 급증하는 전력 수요에 대응하여 최고 수준의 전력 효율을 제공합니다.',
    description2: '우리의 기술은 GLOBAL ONLY ONE으로, 세계 어디서도 찾을 수 없는 독특한 기술력을 가지고 있습니다.\n세피스와 함께 지속 가능한 에너지 미래를 창조하세요.',
    mission: {
      title: '我们的使命',
      subtitle: '通过节能让地球更年轻',
      slogan1: '赛碧스！电费节省的确切答案',
      slogan2: '企业能源效率의 새로운 기준'
    },
    whatIsSepis: '什么是赛碧斯？',
    sepisFullName: '节能综合电力改善系统',
    sepisAcronym: {
      s1: '节约',
      e: '能源',
      p: '电力',
      i: '改善',
      s2: '系统'
    },
    sepisFullTitle: '节能电力改善系统',
    aboutUs: '关于我们',
    synergy: '技术与解决方案의 완벽한 결합',
    synergyDesc: '제조업체 공간에너지의 독특한 기술과 판매업체 세피스의 전문적인 솔루션을 결합하여\n최적의 비용 절감 효과를 제공합니다.',
    manufacturer: '제조업체',
    solutionProvider: '솔루션 공급업체',
    gongganEnergy: '空间能源株式会社',
    gongganDesc: '세피스 기술을 상업화한 세계 최초의 기술 개발 회사입니다. 20년 이상의 연구개발로 GLOBAL ONLY ONE 기술력을 갖추고 있습니다.',
    gongganFeatures: {
      tech: '원본 기술 개발',
      patent: '국내외 여러 특허 및 인증을 획득',
      production: '자체 생산 시설과 품질 관리 시스템'
    },
    sepis: '赛碧스株式会社',
    sepisDesc: '세피스 제품의 국내외 공식 판매 및 기술 지원 전문 회사입니다. 제안부터 설치, 후속 지원까지 일체형 솔루션을 제공합니다.',
    sepisFeatures: {
      consulting: '전문 상담 및 맞춤형 솔루션',
      support: '전국 설치 네트워크 및 기술 지원',
      monitoring: '실시간 모니터링 및 유지보수 서비스'
    },
    synergySectionTitle: '기술과 솔루션의 협력 효과',
    techProvide: '기술 제공',
    solutionProvide: '솔루션 제공',
    integratedSolution: '통합 전력 효율 솔루션',
    techDev: '원본 기술 개발',
    manufacturing: '제품 제조',
    salesConsulting: '판매 및 상담',
    techSupport: '기술 지원',
    missionTitle: '기업 수익성 향상',
    missionSubtitle: '전기 비용 절감으로 경쟁력을 강화',
    missionSavings: '월 평균 2400만 원 절감',
    missionAnnual: '최고 3억 원 절감',
    certifications: {
      title: '특허 및 인증',
      subtitle: '다수의 기술 인정을 받은 특허와 국제 인증을 보유하고 있습니다.',
      patent1: {
        title: '전력 효율 개선 장치',
        number: '특허 제10-1234567호',
        date: '2018.03.15'
      },
      patent2: {
        title: '자기장 제어 시스템',
        number: '특허 제10-2345678호',
        date: '2019.07.22'
      },
      patent3: {
        title: '전력 모니터링 장치',
        number: '특허 제10-3456789호',
        date: '2020.11.08'
      },
      patent4: {
        title: '지능형 절전 시스템',
        number: '특허 제10-4567890호',
        date: '2021.05.30'
      },
      cert1: {
        title: 'ISO 9001',
        org: '품질 관리 시스템 인증',
        date: '2022.01.10'
      },
      cert2: {
        title: 'KC 인증',
        org: '한국 국가 인증',
        date: '2021.09.15'
      },
      cert3: {
        title: 'CE 인증',
        org: '유럽 안전 표준',
        date: '2022.03.20'
      },
      cert4: {
        title: '위험 기업 인증',
        org: '중소 위험 기업부',
        date: '2020.12.01'
      }
    }
  },
  products: {
    label: '产品',
    title: '赛碧스 产品系列',
    subtitle: '各种容量的最佳电力效率解决方案을 제공합니다.',
    industrial: {
      name: '赛碧스 Industrial',
      field: '工业大型设施',
      efficiency: '节省35%'
    },
    commercial: {
      name: '赛碧스 Commercial',
      field: '商业建筑',
      efficiency: '节省30%'
    },
    residential: {
      name: '赛碧스 Home',
      field: '住宅建筑',
      efficiency: '节省25%'
    },
    smart: {
      name: '赛碧스 Smart',
      field: 'AI数据中心',
      efficiency: '节省40%'
    },
    specs: {
      category: '类别',
      size: '尺寸(mm)',
      weight: '重量(kg)',
      protector: '保护器'
    },
    note: '注意：',
    noteDesc: '제품 사양은 모델에 따라 다릅니다. 설치 환경에 맞는 적절한 용량의 제품을 선택해 주세요. 자세한 문의는 고객센터에 연락해 주세요.',
    featureTitle: '전력 효율 개선 장치',
    featureDesc: '기존 전기 장비와 병렬로 설치하여 전기 장비와 전기 장비에서 발생하는 전력 손실을 줄여 전기 장비 효율을 높이는 시스템입니다.',
    features: {
      principle: {
        title: '작동 원리',
        description: '자유 전자의 충돌 현상을 억제하여 전류 흐름을 개선하는 장치'
      },
      savings: {
        title: '절감 효과',
        description: '복합 부하를 기반으로 일반적으로 발생하는 약 5-8%의 전력 손실을 줄입니다.'
      },
      eco: {
        title: '환경 보호',
        description: '탄소 배출을 줄여 환경 친화적인 에너지 사용을 실현합니다.'
      },
      stability: {
        title: '안정성 및 수명 연장',
        description: '전력 품질 개선으로 전기 시설 수명을 연장합니다. 내장된 전원 보호 회로로 완전한 안정성을 보장합니다.'
      }
    },
    roi: {
      title: '투자 회수 기간',
      description: '세피스를 설치한 후, 총 평균',
      savings: '전력 절감 효과,',
      recovery: '투자 비용을 복구할 수 있습니다.'
    },
    warranty: {
      title: '보증 기간 및 수명',
      period: '세피스 무료 보증 기간: 3년',
      lifespan: '세피스 수명: 10년'
    }
  },
  process: {
    badge: '무위험 프로세스',
    title: '신뢰할 수 있도록',
    subtitle: '확신할 수 없는 절감 효과가 있을 경우, 계약을 체결하지 않습니다.\n실제 데이터 검증 후 투명한 프로세스입니다.',
    highlight: '핵심',
    steps: {
      step1: {
        title: '무료 현장 진단',
        description: '전문가가 현장에서 전력 사용 패턴을 분석하고 잠재적인 절감 금액을 계산합니다.'
      },
      step2: {
        title: '1-2개월 예측량',
        description: '세피스를 실제 환경에 설치하여 정확한 절감 금액과 투자 회수 기간을 측정합니다.'
      },
      step3: {
        title: '절감률 확인 후 계약',
        description: '측정 데이터를 사용하여 실제 비용 절감 효과를 확인한 후 계약을 체결합니다.'
      },
      step4: {
        title: '설치 및 후속 지원',
        description: '전문 기술자로 설치를 완료하고, 3년 무료 보증과 지속적인 모니터링을 제공합니다.'
      }
    },
    warranty: {
      freeWarranty: '3년 무료 보증',
      freeWarrantyDesc: '제품 결함 및 성능 보증',
      lifespan: '10년 수명',
      lifespanDesc: '장기 안정적인 운영',
      roi: '13개월 투자 회수',
      roiDesc: '빠른 투자 수익'
    },
    cta: '즉시 무료 현장 진단 신청',
    ctaButton: '무료 진단 신청'
  },
  featuresPage: {
    title: 'AI 시대의 전력 효율의 새로운 기준',
    subtitle: '세피스와 함께 에너지 비용을 줄이고, 지속 가능한 미래를 창조합니다.',
    case1: {
      title: '案例1. 현대 자동차 1급 주요 공급업체 SY 회사: 테스트 부하 5Kw 로봇 용접기'
    },
    case2: {
      title: '案例2. 현대 자동차 주요 공급업체 SW Tech 회사: 220V, 440V 생산 장비'
    },
    case3: {
      title: '案例3. S人寿 9월洞 대搂: 설치 용량 1,200KVA'
    },
    otherCases: '다른 세피스 설치 사례'
  },
  productOverview: {
    label: '제품 개요',
    title: '전력 효율 개선 장치(세피스)는 기존 전기 장비와 병렬로 설치하여 전기 장비와 전기 장비에서 발생하는 전력 손실을 줄여 전기 장비 효율을 높이는 시스템입니다.',
    description1: '설치 후 평균 5.0%의 전력 절감 효과를 얻을 수 있으며, 13개월 만에 투자 회수를 복구할 수 있습니다.',
    description2: '',
    features: {
      surge: {
        title: '浪涌 제거',
        description: '자체 개발한 TVSS 기술로 전력 시스템에서 발생하는 왕성 제거.'
      },
      noise: {
        title: '노이즈 감소',
        description: '전원 노이즈를 줄이고, 주파수에 비례하는 인덕스론 손실을 줄입니다.'
      }
    },
    callouts: {
      loss: {
        title: '손실 감소',
        description: '자기장이 발생한 루렌츠 힘은 전선 내의 전자에게 작용하여 전자와 진동 원자 간의 충돌 횟수를 줄여 저항 생성된 열 손실을 줄입니다.'
      },
      stability: {
        title: '전압 및 전류 파형 안정화',
        description: '안정적인 전력 공급을 제공하여 전기 시설의 수명을 연장합니다.'
      }
    }
  },
  technology: {
    label: 'TECHNOLOGY',
    title: '부자기 효과',
    titleAccent: '기술',
    subtitle: '세피스 독특한 전력 효율 기술',
    principle: {
      title: '세피스 기술 원리',
      subtitle: '1. 부자기 효과',
      year: '1851년, Kelvin',
      description: '전류를 통한 얇은 철판 주변에 자기장을 형성할 때 저항이 줄어듭니다.',
      term: '이것은 부자기 효과(Negative Magneto Resistance)이라고 합니다.',
      effect: '자기장이 발생한 루렌츠 힘은 철판 내의 전자에게 작용하여 전자와 진동 원자 간의 충돌을 억제하여 저항과 저항 생성된 열 손실을 줄입니다.'
    },
    principle2: {
      subtitle: '2. 자기장의 전자 이동 속도 향상 효과',
      intro: '기존 전기 장비 주변에서 적절한 자기장을(B) 외부에서 제공할 때',
      point1: '① 특정 방향으로 자유 전자의 이동 속도가 증가하여 전선(부하) 내 저항 감소 효과',
      point2: '② 자유 전자 등속 운동과 원주 운동으로 인한 투명도 손실을 줄입니다.',
      effect: '자유 전자(e)의 운동 특성을 개선하여 전자 손실을 줄이고, 이동 속도를 증가시켜 전류 흐름을 원활하게 하고, 전류 흐름을 개선합니다.'
    },
    principle3: {
      subtitle: '6. 전자 이동 속도와 세피스의 안정성 특성의 관계',
      title: '세피스 설치 위치(예: 자기장 공급 장치가 있는 분배판)와 전기 장비 사이에 일정한 거리(최소 10m 이상)가 있을 경우',
      highlight: '자기장 개선된 전류 흐름이 장비에 영향을 미치는 데 일정 시간(일반적으로 약 1주일)이 소요됩니다.',
      point1: {
        title: '따라서, 자유 전자의 이동 속도는',
        highlight: '안정화(노화) 특성',
        description: '세피스와 매우 밀접하게 관련됩니다.'
      },
      point2: {
        title: '일반적으로, 전선 내 자유 전자의 속도는 매우 느립니다.',
        highlight: '（자유 전자 이동 1m에 약 1시간 50분이 소요됩니다.）.',
        subpoints: {
          intro: '우리는 전원을 연결할 때 전기 장치가 즉시 작동하는 이유는_',
          point1: '전선 내에 이미 많은 양의 자유 전자가 있습니다.',
          point2: '외부 전기장이 적용될 때, 가장 가까운 전기 장치의 자유 전자의 에너지가 부하로 전환됩니다.'
        }
      },
      point3: {
        title: '설치된 절전 장치의 초기 단계에서',
        subpoints: {
          point1: '주변에 거의 무작위 상태의 자유 전자가 작동하고 있으므로 절약 효과가 발생하지 않습니다.',
          point2: '속도가 일치하는 자유 전자가 부하 영역으로 도달할 때 절약 효과가 시작됩니다.'
        }
      },
      point4: {
        title: '이 시점에서, 자유 전자의 실제 이동 방식은 자유 전자 간 완전한 탄성 충돌 과정을 통해 이루어지므로 추가적인 충돌 지연 시간이 발생합니다.'
      }
    },
    principle4: {
      subtitle: '5. 세피스 절전 원리 - 소음 감소',
      intro: '두 개의 조명 장치(조도 제어 기능이 있는)를 테스트한 결과',
      highlight: '조도 제어기에서 발생한 소음을 관찰하고, 세피스를 설치한 후 소음이 감소되었습니다.',
      result: '→ 전력 품질 향상(고장률 감소, 전기 장비 수명 연장 등)'
    },
    principle5: {
      subtitle: '5. 세피스와 전열 장치의 관계',
      intro: '자기장의 전력 효율 개선 지원 장치가 전선 주변 특정 방향으로 강한 자기장을 형성하여 자유 전자의 운동을 일치시켜',
      point1: '이 방식으로 자유 전자의 저항 손실을 줄여 절전 효과를 얻습니다.',
      point2: '따라서, 저항 열 발생 효과를 사용하는 장치(예: 전열기)에 이 장치를 적용할 때는 실제 절약 효과를 기대할 수 없습니다.',
      point3: '수학식으로 표현하면 다음과 같습니다.',
      formula: {
        title: '즉, 전력 효율 개선 지원 장치가 분모(입력 전력)를 줄이지만',
        point1: '분자(열)도 줄어들기 때문에',
        point2: '자기장은 거의 절전 효과를 일으키지 않습니다.'
      },
      conclusion: {
        title: '결론적으로,',
        point1: '자기장의 전력 효율 개선 장치',
        point2: '이용 전위 차(예: 모터)의 효율을 개선하는 데 더 적합합니다.',
        point3: '저항 열 발생 효과를 사용하는 장치(예: 전열기)는 적합하지 않습니다.'
      }
    },
    cards: {
      magnetic: {
        name: '부자기 효과\n적용',
        description: '자기장 변화에 따른 저항 감소 효과를 최대한으로 줄여 전력 손실을 최소화합니다.'
      },
      efficiency: {
        name: '실시간 전력\n최적화',
        description: 'AI 기반 알고리즘을 사용하여 전력 사용 패턴을 분석하고 최적의 효율을 유지합니다.'
      },
      stability: {
        name: '전압 안정\n시스템',
        description: '전압 변동을 자동으로 감지하고 정정하여 안정적인 전력 공급을 보장합니다.'
      },
      monitoring: {
        name: '지능형 모니터링',
        description: '전력 사용량과 절약 효과를 실시간으로 모니터링하고 보고서를 제공합니다.'
      }
    },
    features: {
      surge: {
        title: '浪涌 제거',
        description: '자체 개발한 TVSS 기술로 전력 시스템에서 발생하는 왕성 제거.'
      },
      noise: {
        title: '노이즈 감소',
        description: '전원 노이즈를 줄이고, 주파수에 비례하는 인덕스론 손실을 줄입니다.'
      },
      loss: {
        title: '손실 감소',
        description: '자기장이 발생한 루렌츠 힘은 전선 내의 전자에게 작용하여 전자와 진동 원자 간의 충돌 횟수를 줄여 저항 생성된 열 손실을 줄입니다.'
      },
      stability: {
        title: '전압 및 전류 파형 안정화',
        description: '안정적인 전력 공급을 제공하여 전기 시설의 수명을 연장합니다.'
      }
    },
    lossReduction: {
      title: '3. 세피스 절전 원리 - 손실 감소',
      mainDesc: '자기장이 발생한 루렌츠 힘은 전선 내의 전자에게 작용하여 전자와 진동 원자 간의 충돌 횟수를 줄여 저항 생성된 열 손실을 줄입니다.',
      point1: '전류 흐르는 전선에 자기장을 적용할 때, 루렌츠 힘은 전자 운동 방향을 일치시킵니다.',
      point2: '일치한 전자와 원자의 충돌 횟수를 줄이면 저항이 줄어듭니다.',
      point3: '저항이 줄어들면 열 손실이 줄어들고, 전력 효율이 향상됩니다.',
      withoutMagnetic: '자기장을 적용하지 않을 때',
      withoutPoint1: '전자 무작위 운동',
      withoutPoint2: '원자와 자주 충돌',
      withoutPoint3: '고 저항과 열 손실',
      withMagnetic: '자기장을 적용할 때',
      withPoint1: '전자 일치 운동',
      withPoint2: '원자 충돌 감소',
      withPoint3: '저항 감소, 효율 향상',
      effectTitle: '손실 감소 효과',
      effect1: '저항 열 감소 최소화',
      effect2: '전력 효율 향상',
      effect3: '전기 장비 수명 연장',
      effect4: '전력 비용 감소'
    },
    surgeRemoval: {
      title: '4. 세피스 절전 원리 - 浪涌 제거',
      causeTitle: '浪涌 발생 원인',
      causeDesc: '전기 제품 수명을 단축하는 왕성은 전기 배터리 스위치를 작동하거나 무거운 장비(압축기, 대형 모터, 전기 용접기 등)를 작동할 때 자주 발생합니다.',
      methodTitle: '세피스 왕성 억제 방법',
      methodDesc: '자체 개발한 TVSS 기술을 사용하여 선택적으로 전원 측으로 흐르는 과전압(왕성)을 제거합니다. 세피스는 정상 전압이 흐를 때 회로를 고저항(비전도체) 상태로 유지하여 시스템에 영향을 미치지 않습니다. 과전압이 흐를 경우, 회로를 저항 값으로 형성하여 과전압을 해체합니다.',
      suppressorTitle: '과전압 억제 장치',
      highImpedance: '고저항(비전도체)',
      surgeSuppress: '스위치 왕성과 과전압 억제',
      qualityImprove: '전력 품질 개선, 에너지 손실 감소',
      processTitle: '과전압 억제 과정',
      power: '전원',
      normalVoltage: '정상 전압',
      operatingVoltage: '작동 전압',
      surgeDetect: '과전압 검출',
      surgeReduce: '왕성 감소',
      qualityImproveShort: '전력 품질 개선',
      specTitle: '작동 전압 규격'
    }
  },
  features: {
    title: 'AI 시대의 전력 효율의 새로운 기준',
    subtitle: '세피스와 함께 에너지 비용을 줄이고, 지속 가능한 미래를 창조합니다.',
    cta: '효율 확인',
    stats: {
      efficiency: '평균 절감율',
      certified: '국제 인증',
      clients: '고객',
      awards: '수상 기록'
    }
  },
  testimonial: {
    quote: '세피스를 도입한 후, 전력 비용이 30% 감소했습니다. 초기 투자에 비해 투자 수익률이 매우 뛰어났으며, 안정적인 전력 공급으로 생산성을 향상시켰습니다.',
    name: '김철수',
    position: '설비 관리 책임자, 한국 제조 주식회사',
    cta: '더 많은 평가 보기'
  },
  contact: {
    title: '联系我们',
    subtitle: '세피스에 대해 궁금한 점이 있으시면 언제든지 문의해 주세요.',
    companyName: '세피스 주식회사',
    form: {
      name: '이름',
      email: '이메일',
      company: '회사 이름',
      phone: '연락처',
      message: '문의 내용',
      submit: '문의 보내기',
      success: '문의가 성공적으로 전송되었습니다.',
      error: '문의 전송이 실패했습니다. 다시 시도해 주세요.'
    },
    info: {
      address: '경기도 고양시 덕양구 동축로 60번길 Ace High-End Tower 811호',
      addressLabel: '주소',
      phone: '02.6052.1888',
      phoneLabel: '전화',
      email: 'support@kosepis.com',
      emailLabel: '이메일',
      hours: '영업일 09:00 - 18:00',
      hoursLabel: '영업 시간'
    }
  },
  footer: {
    tagline: '전력 효율의 미래를 이끌어가는',
    manufacturer: '제조업체：',
    seller: '판매업체：',
    products: {
      title: '제품',
      lineup: '제품 시리즈',
      specs: '기술 사양',
      cases: '적용 사례',
      download: '다운로드'
    },
    company: {
      title: '회사',
      about: '회사 소개',
      history: '연혁',
      certification: '인증',
      partners: '파트너'
    },
    support: {
      title: '지원',
      faq: '자주 묻는 질문',
      guide: '설치 가이드',
      inquiry: '문의',
      service: '고객 지원'
    },
    copyright: '© 세피스 2025',
    rights: 'All rights reserved',
    newsletter: {
      title: '최신 소식과 기술 정보를\n구독하세요.',
      placeholder: '이메일 주소를 입력하세요.',
      button: '구독'
    },
    vision: {
      line1: '절감',
      line2: '지속 가능한 미래',
      line3: '세피스와 함께'
    },
    legal: {
      privacy: '개인 정보 보호 정책',
      terms: '이용 약관'
    }
  },
  language: {
    ko: '한국어',
    en: 'English',
    zh: '中文'
  }
};
